var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.icons.length)?_c('div',[_c('div',{staticClass:"icon-title"},[_vm._v(_vm._s(_vm.$t('PRODUCT_ADD_ALL_EXPOSURE_ICON')))]),_c('ul',{staticClass:"icons-align"},_vm._l((_vm.icons),function(ref,index){
var stickerNo = ref.stickerNo;
var stickerType = ref.stickerType;
var content = ref.content;
return _c('li',{key:stickerNo},[_c('input',{attrs:{"type":"checkbox","name":'icon-list' + index,"disabled":_vm.stickerInfosSync.find(function (ref) {
	var displayStartedAt = ref.displayStartedAt;
	var no = ref.stickerNo;

	return displayStartedAt && no === stickerNo;
}) || _vm.isImmutable},domProps:{"value":stickerNo,"checked":_vm.stickerInfosSync.find(function (ref) {
	var no = ref.stickerNo;

	return no === stickerNo;
})},on:{"focus":function($event){return _vm.deleteIconsError()},"change":function (ref) {
	var target = ref.target;

	return _vm.handleIconNos(target.value);
}}}),(stickerType === 'TEXT')?_c('label',[_vm._v(" "+_vm._s(content)+" ")]):_c('label',[_c('img',{attrs:{"src":content,"alt":content,"width":"90px","height":"30px"}})])])}),0),_c('div',{staticClass:"icon-title",staticStyle:{"margin-top":"15px"}},[_vm._v(" "+_vm._s(_vm.$t('PRODUCT_ADD_DATE_EXPOSURE_ICON'))+" "),_c('PeriodDateCalendar',{staticClass:"date-picker_area",attrs:{"startYmdt":_vm.startYmdt,"endYmdt":_vm.endYmdt,"option":_vm.CheckIconsPeriodOption,"disabled":_vm.isImmutable},on:{"update:startYmdt":function($event){_vm.startYmdt=$event},"update:start-ymdt":function($event){_vm.startYmdt=$event},"update:endYmdt":function($event){_vm.endYmdt=$event},"update:end-ymdt":function($event){_vm.endYmdt=$event}}})],1),_c('ul',{staticClass:"icons-align"},_vm._l((_vm.icons),function(ref,index){
var stickerNo = ref.stickerNo;
var stickerType = ref.stickerType;
var content = ref.content;
return _c('li',{key:stickerNo},[_c('input',{attrs:{"type":"checkbox","name":'icon-list' + index,"disabled":_vm.stickerInfosSync.find(function (ref) {
	var displayStartedAt = ref.displayStartedAt;
	var no = ref.stickerNo;

	return !displayStartedAt && no === stickerNo;
}) || _vm.isImmutable},domProps:{"value":stickerNo,"checked":_vm.stickerInfosSync.find(function (ref) {
	var no = ref.stickerNo;

	return no === stickerNo;
})},on:{"focus":function($event){return _vm.deleteIconsError()},"change":function (ref) {
	var target = ref.target;

	return _vm.handleIconNos(target.value, true);
}}}),(stickerType === 'TEXT')?_c('label',[_vm._v(" "+_vm._s(content)+" ")]):_c('label',[_c('img',{attrs:{"src":content,"alt":content,"width":"90px","height":"30px"}})])])}),0)]):_c('div',[_vm._v(_vm._s(_vm.$t('PRODUCT_ADD_NO_ICONS')))]),(_vm.error.hasOwnProperty('INVALID_STICKER'))?_c('div',{staticClass:"form_guide_fail ncp_fail"},[_vm._v(" "+_vm._s(_vm.$t('PRODUCT_ADD_CANT_CHANGE_ICONS'))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }